var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteCoche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.84 6.189c-.138-.17-.342-.267-.557-.267h-2.725c-.672-1.79-1.548-3.545-2.544-4.207-3.445-2.287-12.582-2.287-16.027 0-.996.663-1.869 2.42-2.545 4.207H.717c-.216 0-.42.098-.556.267-.136.167-.19.39-.146.603L.42 8.766c.069.336.363.577.702.577h.807c-.78.907-1.157 2.05-1.162 3.193-.005 1.412.526 2.688 1.497 3.591.011.01.022.016.032.026v2.762c0 .598.482 1.085 1.075 1.085h2.514c.594 0 1.075-.487 1.075-1.085v-1.11H21.04v1.11c0 .598.482 1.085 1.076 1.085h2.513c.593 0 1.076-.487 1.076-1.085v-2.708c1.03-.953 1.523-2.264 1.53-3.573.004-1.182-.391-2.367-1.216-3.293h.86c.341 0 .635-.24.703-.577l.404-1.973c.042-.212-.01-.433-.147-.602zM7.167 3.528c2.746-1.824 10.918-1.824 13.662 0 .534.353 1.22 1.78 1.849 3.529H5.32c.627-1.748 1.314-3.175 1.847-3.53zm-3.216 9.28c0-1.18.948-2.135 2.115-2.135 1.17 0 2.116.955 2.116 2.135 0 1.18-.946 2.135-2.116 2.135-1.167 0-2.115-.956-2.115-2.135zm18.008 2.135c-1.168 0-2.115-.956-2.115-2.135 0-1.18.947-2.135 2.115-2.135 1.17 0 2.116.955 2.116 2.135 0 1.18-.948 2.135-2.116 2.135z",
    transform: "translate(0 4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteCoche);
export default __webpack_public_path__ + "static/media/transporte-coche.2772a329.svg";
export { ForwardRef as ReactComponent };